module.exports = __webpack_public_path__ + "img/404.7de6e6e1.png";